import i18n from '@dms/i18n';

import {OverLimitPlatform} from './getOverLimitPlatforms';

export function formatOverLimitWarning(platform: OverLimitPlatform): string {
  return `${platform.platformTitle}: ${platform.count} / ${platform.limit} (${i18n.t('page.advertisement.labels.exceededBy')} ${platform.count - platform.limit})`;
}

export function formatOverLimitWarnings(platforms: OverLimitPlatform[]): string {
  return platforms.map(formatOverLimitWarning).join('\n');
}
